var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHiredlyMiniLogo = function SvgHiredlyMiniLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hiredly-mini-logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#hiredly-mini-logo_svg__b)",
    d: "M26.125.5h-26v26h26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.767 6.6q1.508 0 1.508 1.51V20.4h-1.958q-1.509 0-1.509-1.51v-3.71h-5.444v5.22h-1.94q-1.508 0-1.499-1.51V6.6h1.931q1.508 0 1.508 1.51v4.032h5.444V6.6z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hiredly-mini-logo_svg__b",
    x1: -0.167,
    x2: 30.34,
    y1: 0.468,
    y2: 6.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#983EBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#213DB5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hiredly-mini-logo_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    x: 0.125,
    y: 0.5,
    fill: "#fff",
    rx: 4
  })))));
};
export default SvgHiredlyMiniLogo;